import React from 'react';
import {observer} from 'mobx-react';
import {InteractiveTable} from 'components';
import DocumentFoldersState from '../state/DocumentFoldersState';
import {t, withState, types, endpoints} from 'shared/core';
import SubNav from 'company_settings/SubNav';
import EditDocumentFolderModal from './EditDocumentFolderModal';
import DocumentFolder from 'stores/document_folders/DocumentFolder';

const COLUMNS = [
  {
    header: 'company_settings.document_folders.Name',
    attribute: 'name',
    width: 11
  }
];

const LOCALIZATION = {
  removeModal: {
    header: 'company_settings.document_folders.Delete Document Folder',
    subHeader: 'company_settings.document_folders.Are you sure you want to delete this folder?',
    body: 'company_settings.document_folders.DELETE_FOLDER_MESSAGE'
  },
  interactive: {
    addModel: 'company_settings.document_folders.+ Add a Folder',
  },
  emptyState: 'company_settings.document_folders.No folders to display'
};

const DocumentFoldersContainer = observer(({uiState}) => {
  return (
    <div>
      <SubNav title={t('company_settings.subnav.Document Folders')}/>
      <div className='Container mb4'>
        <InteractiveTable
          uiState={uiState}
          title={t('company_settings.document_folders.Document Folders')}
          columns={COLUMNS}
          localization={LOCALIZATION}
          searchable={false}
          onMount={agent => uiState.setInteractiveAgent(agent)}
          proxy={{
            type: 'async',
            modelType: types.FOLDER,
            model: DocumentFolder,
            endpoint: endpoints.FOLDERS.ALL,
          }}
          onRemove={folder => uiState.deleteDocumentFolder(folder)}
          onEdit={folder => uiState.editDocumentFolder(folder)}
          onAdd={() => uiState.addDocumentFolder()}/>
        <EditDocumentFolderModal uiState={uiState}/>
      </div>
    </div>
  );
});

export default withState(DocumentFoldersContainer, DocumentFoldersState);